import { FacetsManager } from "@client/components/Search/Extensions/facets-search.class";
import SearchHeader from "@client/components/Search/Extensions/SearchHeader.class";
import EventManager from "@common/helpers/EventManager.class";
import DirtyManager from "@client/components/Search/Extensions/DirtyManager.class";
import BrandProductQuery from "@client/components/Search/Query/brand-product-query.class";
import SearchKeyword from "@client/components/Search/Extensions/search-keyword.class";

import { events } from "@common/helpers/events";
import { check, unCheck, styleCheckBox } from "@common/helpers/styledCheckBox";
import { $elementChild } from "@common/helpers/elements";

export default class BrandProductSearch extends SearchKeyword {
	discontinuedName: string;
	facetsManager: FacetsManager<BrandProductQuery>;
	searchHeader: SearchHeader;
	$discontinuedCheckbox: any;
	discontinuedVisible: boolean;
	constructor($ownerModule: HTMLElement) {
		const eventManager = new EventManager();
		const dirtyManager = new DirtyManager();
		const query = new BrandProductQuery();

		super($ownerModule, eventManager, dirtyManager, query);

		this.isApi = true;
		this.discontinuedName = "Discontinued";
		this.facetsManager = new FacetsManager($ownerModule, eventManager, dirtyManager, query);
		this.searchHeader = new SearchHeader($ownerModule, eventManager, query);
		this.$discontinuedCheckbox = $elementChild(this.$module, "discontinuedselect");
		// @ts-expect-error unsure about type of showDiscontinuedFacet
		this.discontinuedVisible = window.config.search.showDiscontinuedFacet === "True";
		this.facetsManager.initFacets();
		this.searchHeader.initHeader(this.queryObject.getPagingData().pageSize);

		this.tab = "brandproducts";

		this.$module = $ownerModule;

		this.eventManager.on(this, events.search.CHANGE_PAGE_SIZE, this.onPageSizeChanged.bind(this));
		this.eventManager.on(this, events.search.RENDERED, this.facetsManager.renderCurrentFilters.bind(this.facetsManager));
		this.eventManager.on(this, events.search.RENDER, this.setDirtyStatus.bind(this));
		this.eventManager.on(this, events.search.FACET_CLEAR_ALL, this.uncheckDiscontinued.bind(this), true);

		if (this.discontinuedVisible) {
			this.eventManager.on(this, events.search.RENDERED, this.setDiscontinuedState.bind(this));

			styleCheckBox(this.$discontinuedCheckbox);

			if (query.queryData.showdiscontinuedproducts) {
				check(this.$discontinuedCheckbox);
			}

			this.$discontinuedCheckbox.parentElement.addEventListener("click", () => {
				if (this.$discontinuedCheckbox.checked) {
					this.showDiscontinuedProducts(true);
				} else {
					this.showDiscontinuedProducts(false);
				}

				this.search();
			});
		}
	}

	uncheckDiscontinued() {
		if (this.discontinuedVisible) {
			unCheck(this.$discontinuedCheckbox);
			this.queryObject.queryData.showdiscontinuedproducts = false;
		}
	}

	setDirtyStatus() {
		if (this.discontinuedVisible) {
			if (this.$discontinuedCheckbox.checked) {
				this.dirtyManager.setDirty(this.discontinuedName);
			} else {
				this.dirtyManager.removeDirty(this.discontinuedName);
			}
		}
	}

	showDiscontinuedProducts(state) {
		this.queryObject.queryData.showdiscontinuedproducts = state;
	}

	setDiscontinuedState(state) {
		if (state.showdiscontinuedproducts) {
			check(this.$discontinuedCheckbox);
		} else {
			unCheck(this.$discontinuedCheckbox);
		}
	}

	onPageSizeChanged() {
		this.search();
	}
}
